import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import FormControl from "@material-ui/core/FormControl";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core";
import ButtonWithSpinner from "../ButtonWithSpinner";
import TicketsAlterarEtapaSelect from "../TicketsAlterarEtapaSelect";
import { BotaoCancelar, BotaoConfirmar } from "../BotoesModal";

const useStyles = makeStyles((theme) => ({
	maxWidth: {
		width: '100%',
	},
}));

const TicketAlterarEtapa = ({ modalOpen, onClose, user }) => {
	const [selectedQueue, setSelectedQueue] = useState("");
	const [loading, setLoading] = useState(false);

	const classes = useStyles();

	useEffect(() => {
		setLoading(false);
		setSelectedQueue("");
	}, [modalOpen]);

	const handleClose = async () => {
		setLoading(true);
		await onClose(selectedQueue);
		setLoading(false);
	};

	const handleCancel = () => {
		setSelectedQueue("");
		onClose();
	};

	return (
		<Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth="xs">
			<DialogTitle id="form-dialog-title">
				Alterar etapa do lead
			</DialogTitle>
			<DialogContent dividers>
				<FormControl variant="outlined" className={classes.maxWidth}>
					<TicketsAlterarEtapaSelect
						userId={user.id}
						onChange={(value) => setSelectedQueue(value)}
					/>
				</FormControl>
			</DialogContent>
			<DialogActions>
				<BotaoCancelar onClick={() => handleCancel()} disabled={loading}>
					Cancelar
				</BotaoCancelar>
				<BotaoConfirmar type="button" onClick={() => handleClose()} loading={loading}>
					Alterar
				</BotaoConfirmar>
			</DialogActions>
		</Dialog>
	);
};

export default TicketAlterarEtapa;
